import { Box, Typography } from '@mui/material'
import { rankOrderSuffix } from 'utils/rankOrderSuffix'
interface IReportHeading {
  metricValue: string
  rank: number
  currentYear: number
  countryName: string | undefined
  Flag: any
}

const ReportHeading: React.FC<IReportHeading> = ({ metricValue, currentYear, countryName, rank, Flag }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#c2ddee',
        borderRadius: '30px',
        padding: '25px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Typography variant='body2' component='h1'>
          {currentYear} AI Vibrancy Profile
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Typography className='headingWidthOverride' variant='h4' component='h2'>
            {countryName}
          </Typography>
          <Flag height={40} width={80} style={{ marginRight: '10px' }} />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            mr: '50px',
          }}
        >
          <Typography variant='body2' component={'h1'}>
            Overall Rank:
          </Typography>
          <Typography
            className='headingWidthOverride'
            variant='h4'
            component='h3'
            sx={{ fontWeight: 'bold' }}
            style={{ margin: 0 }}
          >
            {rank}
            {rankOrderSuffix(rank)}
          </Typography>
        </Box>
        <Box
          sx={{
            padding: '15px',
            border: 'solid',
            borderColor: 'black',
            borderWidth: '1px',
            borderRadius: '20px',
            textAlign: 'center',
            width: '120px',
            backgroundColor: '#fff',
            alignItems: 'center',
            display: 'flex',
            height: '66px',
          }}
        >
          {metricValue}
        </Box>
      </Box>
    </Box>
  )
}

export default ReportHeading
